import httpClient, { clearLeadsCache } from './httpClient';

export default {
  getSingleLeadDetails: leadID => httpClient.get(`api/lead/get/${leadID}?decrypt=1`),
  getLeads: (offset, type, params, integrationId) => {
    if (integrationId) {
      return httpClient.get(`api/leads/get/${integrationId}/${type}/${offset}`, { params });
    }
    return httpClient.get(`api/leads/get/${type}/${offset}`, { params });
  },
  fetchAndDownloadLeads: (type, params, integrationId) => {
    if (integrationId) {
      return httpClient.get(`api/leads/export/${integrationId}/${type}`, {
        params,
        responseType: 'blob',
      });
    }
    return httpClient.get(`api/leads/export/${type}`, {
      params,
      responseType: 'blob',
    });
  },
  resendLeadEmails: leadId => httpClient.post(`api/lead/resend-emails/${leadId}`),
  softDeleteLeads: payload => httpClient.post('api/lead/soft-delete-leads', payload),
  getChatHistory: (leadId, params = {}) => {
    return httpClient.get(`api/lead/${leadId}/chat-history`, { params });
  },
  getConsumerInventoryMatchInfo: (leadId, page, limit, filter, dealerMbids = null) => {
    const params = { page, limit, filter };
    if (dealerMbids && dealerMbids.length) {
      params.dealerMbids = dealerMbids.join(',');
    }
    return httpClient.get(`api/lead/${leadId}/consumer-inventory-matched-vehicles`, { params });
  },
  getIDVReport: (consumerId, leadId, transactionId) => {
    return httpClient.get(`api/v3/consumers/${consumerId}/leads/${leadId}/idv/${transactionId}/report`);
  },
  clearLeadsCache: () => clearLeadsCache(),
};
